export var RevenueReportAggregateEnum = /*#__PURE__*/ function(RevenueReportAggregateEnum) {
    RevenueReportAggregateEnum["Day"] = "day";
    RevenueReportAggregateEnum["Week"] = "week";
    RevenueReportAggregateEnum["Month"] = "month";
    RevenueReportAggregateEnum["Quarter"] = "quarter";
    RevenueReportAggregateEnum["Year"] = "year";
    RevenueReportAggregateEnum["AllTime"] = "all-time";
    return RevenueReportAggregateEnum;
}({});
export var RevenueReportSortColumnId = /*#__PURE__*/ function(RevenueReportSortColumnId) {
    RevenueReportSortColumnId["CompanyName"] = "companyName";
    RevenueReportSortColumnId["ServiceName"] = "serviceName";
    RevenueReportSortColumnId["Revenue"] = "revenue";
    RevenueReportSortColumnId["Aggregate"] = "aggregate";
    return RevenueReportSortColumnId;
}({});
